import { render, staticRenderFns } from "./createEditBankAccounts.vue?vue&type=template&id=12d045af&scoped=true&"
import script from "./createEditBankAccounts.vue?vue&type=script&lang=js&"
export * from "./createEditBankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./createEditBankAccounts.vue?vue&type=style&index=0&id=12d045af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d045af",
  null
  
)

export default component.exports